import { StyleSheet } from 'aphrodite';
import { borderColor } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	trigger: {
		background: 'none',
		border: 'none',
		color: '#0070c9',
		cursor: 'pointer',
		fontSize: 12,
		padding: 0,
		':hover': {
			textDecoration: 'underline',
		},
	},
	tooltipContent: {
		maxWidth: 380,
		padding: 0,
		whiteSpace: 'normal',
	},
	tooltipHeader: {
		borderBottom: `1px solid ${borderColor}`,
		fontSize: 13,
		fontWeight: 600,
		padding: '10px 14px',
	},
	policyList: {
		display: 'flex',
		flexDirection: 'column',
	},
	policyCard: {
		borderBottom: `1px solid ${borderColor}`,
		padding: '10px 14px',
		':last-child': {
			borderBottom: 'none',
		},
	},
	policyLob: {
		fontSize: 13,
		fontWeight: 600,
		marginBottom: 4,
	},
	policyDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
	},
	policyDetail: {
		fontSize: 12,
		color: '#4A4A4A',
	},
	detailLabel: {
		color: '#858585',
	},
});
